export function isDevelopment(): boolean {
  return process.env.NODE_ENV === 'development'
}

export function isStaging(): boolean {
  return window.location.host === 'staging.rq.app'
}

export function isFeature(): boolean {
  return window.location.host === 'feature.rq.app'
}

export function isPreProduction(): boolean {
  return window.location.host === 'pre-prod.rq.app'
}

export function isProduction(): boolean {
  return window.location.host === 'refer.rq.app'
}

export function isDocker(): boolean {
  const hostUrl = `${window.location.protocol}//${window.location.host}`

  return hostUrl.includes('host.docker.internal')
}

export function isNotProduction(): boolean {
  return !isProduction()
}

export function getAppUrl() {
  switch (true) {
    case isProduction():
      return 'https://refer.rq.app'
    case isPreProduction():
      return 'https://pre-prod.rq.app'
    case isStaging():
      return 'https://staging.rq.app'
    case isFeature():
      return 'https://feature.rq.app'
    default:
      return 'https://app.rqratings.dev'
  }
}
